import React, { useContext, useState } from 'react';
import Select from '../../Form/Select';

import PlusSquare from '../../../images/donation/plus-square.svg';
import DeleteIcon from '../../../images/donation/delete.svg';
import * as yup from 'yup';
import { AppContext } from '../../../apollo/wrap-root-element';
import { currencySymbols } from '../../../modules/timeline/components/EnterButton/utils';

export default function DonationAmountForm({
  setActiveStep,
  projectsLists,
  defaultSelected,
  formik,
  arrayHelpers,
  onDeleteDonationProject,
}) {
  const { currency } = useContext(AppContext);
  const { values, handleChange, setFieldValue } = formik;

  const amount = ['10', '25', '50', '100'];

  const donatedProjectsLength = formik.values.donatedProjectsLists.length;

  const filteredProjectsLists =
    donatedProjectsLength === 1
      ? projectsLists
      : projectsLists.filter(
          (item) =>
            !formik.values.donatedProjectsLists
              .slice(0, donatedProjectsLength - 1)
              .some((selectedProject) => selectedProject.projectID === item.value)
        );

  const unselectedProjectList = projectsLists.filter((item) => {
    return !formik.values.donatedProjectsLists.some((selectedProject) => selectedProject.projectID === item.value);
  });

  return (
    <>
      <form className="form-donate-amount form">
        <p className="m-y-32 form-title">Give to Lineage Journey</p>
        <div className="donation-projects-lists m-t-32">
          {formik.values.donatedProjectsLists.map((item, index) => {
            const projectDetails = projectsLists?.find((pl) => pl.value === item.projectID);
            const countryImageUrl = `https://flagcdn.com/h24/${projectDetails?.flagCode}.png`;
            if (index === donatedProjectsLength - 1) {
              return null;
            }
            return (
              <div className="donation-projects-items">
                <div style={{ display: 'flex', width: '50%' }}>
                  <p style={{ fontSize: '14px', fontWeight: 700, color: '#656565' }}>
                    {index + 1}
                    {'.         '}
                  </p>
                  <p
                    style={{
                      fontSize: '14px',
                      marginRight: '14px',
                      fontWeight: 700,
                      color: '#656565',
                      marginLeft: '4px',
                    }}
                  >
                    {projectDetails?.label}
                  </p>
                  {projectDetails?.flagCode && (
                    <img
                      width={'32px'}
                      height={'24px'}
                      style={{ display: 'flex', marginTop: 'auto' }}
                      src={countryImageUrl}
                      alt={countryImageUrl}
                    />
                  )}
                </div>
                <p style={{ fontSize: '16px', fontWeight: 500, color: '#0A0A0A' }}>
                  {currencySymbols[currency]}
                  {item.customAmount ? item.customAmount : item.amount} / {item.donateType}
                </p>
                <button onClick={() => onDeleteDonationProject(index)} style={{ border: 'none' }} type="button">
                  <img src={DeleteIcon} />
                </button>
              </div>
            );
          })}
        </div>

        <div className="m-t-32">
          <div className="donate-section">
            <h2 className="subtitle">Give How Often?</h2>
            <div className="button-group">
              <button
                onClick={() =>
                  setFieldValue(`donatedProjectsLists[${donatedProjectsLength - 1}].donateType`, 'one-time')
                }
                className={`button ${
                  values.donatedProjectsLists[donatedProjectsLength - 1].donateType === 'one-time' ? 'selected' : ''
                }`}
              >
                One Time
              </button>
              <button
                onClick={() =>
                  setFieldValue(`donatedProjectsLists[${donatedProjectsLength - 1}].donateType`, 'monthly')
                }
                className={`button ${
                  values.donatedProjectsLists[donatedProjectsLength - 1].donateType === 'monthly' ? 'selected' : ''
                }`}
              >
                Monthly
              </button>
            </div>
            {values.donatedProjectsLists[donatedProjectsLength - 1].donateType === '' && (
              <p className="error-message">Please select an option.</p>
            )}
          </div>
        </div>
        <div className="m-t-32">
          <label className="form-label">Give How Much?</label>
          <ul className="amount-container m-t-16">
            {amount.map((item) => (
              <li
                className={`amount-item-${
                  item.toString() === values.donatedProjectsLists[donatedProjectsLength - 1].amount.toString()
                    ? 'active '
                    : 'inactive '
                } amount-item `}
                onClick={() => setFieldValue(`donatedProjectsLists[${donatedProjectsLength - 1}].amount`, item)}
              >
                {currencySymbols[currency]}
                {item}
              </li>
            ))}
          </ul>

          <div>
            <input
              className="custom-amount-input m-t-16"
              type="text"
              name={`donatedProjectsLists[${donatedProjectsLength - 1}].customAmount`}
              placeholder={`${currencySymbols[currency]} Custom Amount`}
              onChange={(e) => {
                const numberPattern = /^\d+$/;
                if (numberPattern.test(e.target.value) || e.target.value === '') {
                  setFieldValue(`donatedProjectsLists[${donatedProjectsLength - 1}].customAmount`, e.target.value);
                }
              }}
              value={values.donatedProjectsLists[donatedProjectsLength - 1].customAmount}
            />
          </div>
        </div>
        <div className="form-element m-t-32">
          <label className="label-margin">Give to</label>
          <Select
            name="projectId"
            value={
              projectsLists.find(
                (item) => item.value === values.donatedProjectsLists[donatedProjectsLength - 1].projectID
              )?.label
            }
            onChange={(value) => setFieldValue(`donatedProjectsLists[${donatedProjectsLength - 1}].projectID`, value)}
            button={
              <div className="w-full text-left" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                {
                  projectsLists.find(
                    (item) => item.value === values.donatedProjectsLists[donatedProjectsLength - 1].projectID
                  )?.label
                }
                {projectsLists.find(
                  (item) => item.value === values.donatedProjectsLists[donatedProjectsLength - 1].projectID
                )?.flagCode ? (
                  <img
                    width={'32px'}
                    height={'24px'}
                    style={{ display: 'flex' }}
                    src={`https://flagcdn.com/h24/${
                      projectsLists.find(
                        (item) => item.value === values.donatedProjectsLists[donatedProjectsLength - 1].projectID
                      )?.flagCode
                    }.png`}
                    alt={'img'}
                  />
                ) : null}
              </div>
            }
            className="w-full"
            buttonClass="w-full donation-drop-down"
          >
            {filteredProjectsLists.map((project) => (
              <Select.Option value={project.value} key={project.value}>
                <div style={{ display: 'flex', gap: '15px', alignItems: 'center', cursor: 'pointer' }}>
                  {project.label}
                  {projectsLists.find((item) => item.value === project.value)?.flagCode ? (
                    <img
                      width={'32px'}
                      height={'24px'}
                      style={{ display: 'flex', marginTop: 'auto' }}
                      src={`https://flagcdn.com/h24/${
                        projectsLists.find((item) => item.value === project.value)?.flagCode
                      }.png`}
                      alt={'img'}
                    />
                  ) : null}
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        {unselectedProjectList.length !== 0 ? (
          <div className="form-element ">
            <button
              type="button"
              className="more-donate-button"
              onClick={() => {
                if (+values.donatedProjectsLists[donatedProjectsLength - 1].customAmount === 0) {
                  setFieldValue(`donatedProjectsLists[${donatedProjectsLength - 1}].customAmount`, '');
                } else if (+values.donatedProjectsLists[donatedProjectsLength - 1].customAmount === 1) {
                  setFieldValue(`donatedProjectsLists[${donatedProjectsLength - 1}].customAmount`, '1');
                }
                arrayHelpers.push({
                  projectID: unselectedProjectList[0].value,
                  customAmount: '',
                  amount: '10',
                  donateType: 'monthly',
                });
              }}
            >
              <img src={PlusSquare} />
              <p>Give to more projects</p>
            </button>
          </div>
        ) : null}

        <div className="form-element submit">
          <input
            type="button"
            value="Continue"
            className="btn btn-primary-ii btn-submit continue-button"
            onClick={() => {
              if (+values.donatedProjectsLists[donatedProjectsLength - 1].customAmount === 0) {
                setFieldValue(`donatedProjectsLists[${donatedProjectsLength - 1}].customAmount`, '');
              } else if (+values.donatedProjectsLists[donatedProjectsLength - 1].customAmount === 1) {
                setFieldValue(`donatedProjectsLists[${donatedProjectsLength - 1}].customAmount`, '1');
              }

              setActiveStep(1);
            }}
          />
        </div>
      </form>
    </>
  );
}
